<template>
    <div id="partner-grant">
        <ReferringPlatformGrantModal
            v-if="!loading"
            :referring-platform-slug="platform.slug"
            :auth-callback-url="platform.authCallbackUrl"
            :email="platform.email"
        />
        <page-loader v-else :loading="true"/>
    </div>
</template>

<script>
import UserMixin from "@mixins/UserMixin";
import ReferringPlatformGrantModal from '../../modules/Misc/ReferringPlatformGrantModal';
import {pageRedirect, pageRedirectMainLogout, paramsFromQueryString, paramsToQueryString} from "@helpers/router-helper";
import SetupEngineAxiosMixin from "@packages/integrations/mixins/SetupEngineAxiosMixin";

export default {
    name: "PartnerGrant",
    mixins: [
        UserMixin,
        SetupEngineAxiosMixin,
    ],
    components: {
        ReferringPlatformGrantModal
    },
    data: () => ({
        loading: true,
        params: {},
    }),
    computed: {
        platform() {
            let email = this.params?.email || '';
            if (email === '@') {
                email = this.me?.email  || '';
            }
            return {
                slug: this.params?.referringPlatform || '',
                authCallbackUrl: this.params?.authCallbackUrl || (this.me ? '#' : ''),
                email: email,
            };
        },
        requirementsFulfilled() {
            return this.isAgent && !!this.platform.email && this.me?.email === this.platform.email;
        },
        isAuthorizeReq() {
            return this.requirementsFulfilled && this.platform.slug;
        }
    },
    async created() {
        this.params = paramsFromQueryString(this.$route.query);

        if (!this.requirementsFulfilled) {
            this.me && await pageRedirectMainLogout();
        }

        if (!this.isAuthorizeReq) {
            this.params.email = '';
            await pageRedirect(window.env?.APP_URL, this.me ? '/dashboard' : '/auth?redirectUrl=' + encodeURIComponent(window.env?.APP_URL + '/partner/grant?' + paramsToQueryString(this.params)));
        }

        this.$nextTick(() => this.loading = false);
    },
}
</script>